import * as React from "react";
import { getMatchedSegments } from "../utils";

interface IResultContentProps {
    keyword: string;
    content: string;
}


const ResultContent: React.FC<IResultContentProps> = props => {
    const [segments, setSegments] = React.useState<[string, string, string][]>();
    React.useEffect(() => {
        if (props.keyword) {
            setSegments(getMatchedSegments(props.keyword, props.content));
        }
    }, [props])
    return <>{
        segments?.map(([prefix, keyword, suffix], index) => <div key={index} style={{marginBottom: '1em'}}>
            <span>......</span>
            <span>{prefix}</span>
            <strong style={{color: '#F88'}}>{keyword}</strong>
            <span>{suffix}</span>
            <span>......</span>
        </div>)
    }</>
}

export default ResultContent;
